import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authSlice from './services/controllers/auth/AuthSlice';
import commonSlice from './services/controllers/common/CommonSlice';
import projectSlice from './services/controllers/project/ProjectSlice';
import rewardSlice from './services/controllers/reward/RewardSlice';
import userSlice from './services/controllers/user/UserSlice';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['common', 'reward'],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    common: commonSlice,
    user: userSlice,
    auth: authSlice,
    project: projectSlice,
    reward: rewardSlice,
  }),
);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
